import React from 'react';
import type { StagedUpload } from './types';

/** Green "Signature saved" confirmation shown under a canvas once its drawing
 *  has been staged as an upload. The copy is asserted by the e2e walk. */
export function SavedSignatureNote({ staged }: { staged?: StagedUpload }) {
  if (!staged) return null;
  return (
    <div data-testid="sig-saved-note" className="mt-3 flex items-center gap-3 rounded-xl border border-emerald-100 bg-emerald-50/60 p-3">
      {staged.previewUrl && (
        <img src={staged.previewUrl} alt="Saved signature" className="h-10 rounded border border-gray-200 bg-white" />
      )}
      <span className="text-xs font-medium text-emerald-700">Signature saved. Draw again to replace it.</span>
    </div>
  );
}

/** The quiet note on the screen after an insurance check came back active. */
export function CoverageConfirmedNote({ lines }: { lines: string[] }) {
  if (lines.length === 0) return null;
  return (
    <div role="status" data-testid="coverage-confirmed" className="flex items-start gap-3 rounded-xl border border-emerald-100 bg-emerald-50/60 p-3">
      <svg aria-hidden className="mt-0.5 w-4 h-4 shrink-0 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
      </svg>
      <div className="space-y-1">
        {lines.map((line, i) => (
          <p key={i} className="text-sm font-medium text-emerald-700">{line}</p>
        ))}
      </div>
    </div>
  );
}
